import { Spacing, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as Underline } from 'img/familyBuyTariffsModal/textUnderline.svg';
import React from 'react';
import { familyCalendarsModalTariffsReverse } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import type { BuyFamilyTariffContentProps } from 'reactApp/ui/IframePages/BuyFamilyTariff/BuyFamilyTariff.types';
import { FamilyBenefits } from 'reactApp/ui/IframePages/BuyFamilyTariff/FamilyBenefits/FamilyBenefits';
import { FamilyTariffList } from 'reactApp/ui/IframePages/BuyFamilyTariff/FamilyTariffList/FamilyTariffList';
import { TabsSelector } from 'reactApp/ui/IframePages/BuyFamilyTariff/TabsSelector/TabsSelector';

import styles from './BuyFamilyTariffContent.css';

export const BuyFamilyTariffContent: React.FC<BuyFamilyTariffContentProps> = ({ activeTab, setActiveTab, onBuyClick }) => {
    return (
        <div className={styles.root}>
            <Text className={styles.title}>
                В{' '}семейной подписке появился{'\n'}семейный календарь для{' '}общих дел
                <Underline className={styles.underline} />
            </Text>
            <Spacing size={26} />
            <TabsSelector activeTab={activeTab} setActiveTab={setActiveTab} />
            <Spacing size={18} />
            <div className={classNames(styles.tariffsWrapper, { [styles.tariffsColumnReverse]: familyCalendarsModalTariffsReverse })}>
                <FamilyTariffList activeTab={activeTab} onBuyClick={onBuyClick} />
                <Spacing size={25} />
                <FamilyBenefits />
            </div>
        </div>
    );
};
